'use client';
import Image from 'next/image';

const speakers = [
  {
    name: "Anna L De Bacci",
    designation: "Co-founder & CEO",
    company: "De Bacci Capital",
    imageSrc: "/images/speakers/annadde-bacci.webp",
    alt: "anna-de-bacci",
  },
  {
    name: "Sahil Shah",
    designation: "Head of Investment Operations",
    company: "RealFi (IOG)",
    imageSrc: "/images/speakers/sahil-shah.webp",
    alt: "sahil-shah",
  },
  {
    name: "Silvija Clark",
    designation: "Institutional sales director",
    company: "Burjx",
    imageSrc: "/images/speakers/silvija-clark.webp",
    alt: "silvija-clark",
  },
  {
    name: "Maryna Barysheva",
    designation: "CEO",
    company: "LKI Consulting",
    imageSrc: "/images/speakers/maryna-barysheva-pic.webp",
    alt: "maryna-barysheva",
  },
  {
    name: "Daniel Malinovski",
    designation: "Co-Founder and Director",
    company: "Simplicity Group",
    imageSrc: "/images/speakers/daniel-malinovski.webp",
    alt: "daniel-malinovski",
  },
  // end of 2025 spekaers
  {
    name: "Aly Madhavji",
    designation: "Managing Partner",
    company: "Blockchain Founders Fund",
    imageSrc: "/images/speakers/Aly.webp",
    alt: "Aly",
  },
  {
    name: "Vineet Budki",
    designation: " Partner & CEO",
    company: " Sigma Capital Limited",
    imageSrc: "/images/speakers/Vineet.webp",
    alt: "Vineet",
  },
  {
    name: "Luchang Z",
    designation: "Founding Partner",
    company: "Arcanum Capital",
    imageSrc: "/images/speakers/Luchang.webp",
    alt: "Luchang",
  },
  {
    name: "Laura K. Inamedinova",
    designation: "Cheif Ecosystem Officer",
    company: "Gate ecosystem / GVC",
    imageSrc: "/images/speakers/laura.webp",
    alt: "laura",
  },
   
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.jsx:74:4" data-component-path="src/app/SpeakerSection.jsx" data-component-line="74" data-component-end-line="114" data-component-file="SpeakerSection.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20sm%3Ap-4%22%7D" id='speakers'
      className="w-full p-6 sm:p-8 md:p-10 lg:p-[38px] sm:p-4"
    >
      <div data-component-id="src/app/SpeakerSection.jsx:77:6" data-component-path="src/app/SpeakerSection.jsx" data-component-line="77" data-component-end-line="113" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1540px%5D%22%7D" className="w-full max-w-[1540px]">
        {/* Section Title */}
       <h2 data-component-id="src/app/SpeakerSection.jsx:79:7" data-component-path="src/app/SpeakerSection.jsx" data-component-line="79" data-component-end-line="81" data-component-file="SpeakerSection.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-center%20text-%5B24px%5D%20sm%3Atext-%5B28px%5D%20lg%3Atext-%5B32px%5D%20font-semibold%20mb-8%20bg-%5Blinear-gradient(1deg%2C%2317c64f_0%25%2C%2310b981_50%25%2C%23005529_100%25)%5D%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="text-center text-[24px] sm:text-[28px] lg:text-[32px] font-semibold mb-8 bg-[linear-gradient(1deg,#17c64f_0%,#10b981_50%,#005529_100%)] bg-clip-text text-transparent">
              Past Speakers
            </h2>
        {/* Speaker List Box */}
        <div data-component-id="src/app/SpeakerSection.jsx:83:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="83" data-component-end-line="112" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20%20max-w-%5B1200px%5D%20mx-auto%22%7D" className="w-full  max-w-[1200px] mx-auto">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div data-component-id="src/app/SpeakerSection.jsx:85:10" data-component-path="src/app/SpeakerSection.jsx" data-component-line="85" data-component-end-line="111" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-5%20sm%3Agap-2%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-2 place-items-center">
            {speakers.map((speaker, index) => (
              <div data-component-id="src/app/SpeakerSection.jsx:87:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="87" data-component-end-line="109" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                <div data-component-id="src/app/SpeakerSection.jsx:89:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="89" data-component-end-line="99" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B120px%5D%20h-%5B120px%5D%20sm%3Aw-%5B250px%5D%20sm%3Ah-%5B250px%5D%20relative%20mb-4%22%7D" className="w-[120px] h-[120px] sm:w-[250px] sm:h-[250px] relative mb-4">
                  <Image data-component-id="src/app/SpeakerSection.jsx:90:18" data-component-path="src/app/SpeakerSection.jsx" data-component-line="90" data-component-end-line="98" data-component-file="SpeakerSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-full%22%7D"
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    objectFit="cover"
                     width={300}
                    height={300}
                    className="rounded-full"
                    unoptimized
                  />
                </div>
                <h3 data-component-id="src/app/SpeakerSection.jsx:100:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="100" data-component-end-line="102" data-component-file="SpeakerSection.jsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22bg-%5Blinear-gradient(1deg%2C%2317c64f_0%25%2C%2310b981_50%25%2C%23005529_100%25)%5D%20bg-clip-text%20text-transparent%20text-%5B13px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="bg-[linear-gradient(1deg,#17c64f_0%,#10b981_50%,#005529_100%)] bg-clip-text text-transparent text-[13px] sm:text-[18px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/SpeakerSection.jsx:103:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="103" data-component-end-line="105" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%22%7D" className="text-white text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/SpeakerSection.jsx:106:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="106" data-component-end-line="108" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B10px%5D%20sm%3Atext-%5B12px%5D%20text-center%22%7D" className="text-white text-[10px] sm:text-[12px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
